export default "__VITE_ASSET__BekeLmGC__"